import { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaCloudUploadAlt } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";

import style from "./DocumentUploadModal.module.css";

function DocumentUploadModal({ close, set }) {
  const [files, setFiles] = useState([]);

  return (
    <Modal show={true} size="lg">
      <Modal.Header>
        <h5>آپلود مدارک</h5>
      </Modal.Header>
      <Modal.Body>
        <p>
          اگر هر کدام از مدارک زیر را داشتید، لطفا در فرمت های pdf وتصویر ضمیمه
          کنید
        </p>
        <ul>
          <li>
            <span>کارت بازرگانی</span>
          </li>
          <li>
            <span>مجوز ورود به کشور مقصد</span>
          </li>
          <li>
            <span>مجوز خروج</span>
          </li>
          <li>
            <span>تایید بهداشت (برای مواد غذایی)</span>
          </li>
        </ul>

        <div className="w-100 py-2 px-4">
          <button className={style.wrapper}>
            <div className={style.icon}>
              <FaCloudUploadAlt />
            </div>
            <span>افزودن فایل</span>
            <input
              type="file"
              className={style.upload}
              accept="image/*,application/pdf"
              onChange={e =>
                setFiles(cur => {
                  if (e.target.files[0]) return [...cur, e.target.files[0]];
                  return [...cur];
                })
              }
            />
          </button>
        </div>

        {files.length > 0 && (
          <div className="px-2">
            <h6>لیست فایل ها</h6>
            {files.map((item, idx) => (
              <div
                key={idx}
                className="d-flex justify-content-between border border-1 rounded py-1 px-3 my-2"
              >
                <span className="text-primary">{item.name}</span>
                <button
                  className={style.close}
                  onClick={() =>
                    setFiles(cur => cur.filter((item, index) => index != idx))
                  }
                >
                  <IoMdCloseCircle />
                </button>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn-success-style" onClick={() => set(files)}>
          بعدی
        </button>
        <button className="btn-cancel-style me-2" onClick={close}>
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DocumentUploadModal;
